import { GuestDetailsBuilder } from './guest-details.builder';
export var getAssignedTicket = function () { return ({
    ticketNumber: 'FHRX-5QRL-HU021',
    orderNumber: 'FHRX-5QRL-HU',
    ticketDefinitionId: 'fdcbfaea-e273-4d43-8407-7fbff28aa7a0',
    name: 'Simple ticket',
    price: { amount: '12.00', currency: 'EUR' },
    free: false,
    policy: 'Ticket Policy',
    qrCode: 'https://www.wixevents.com/check-in/FHRX-5QRL-HU021,f527af49-db8e-4bca-a559-2403328177f1',
    checkIn: { created: '2019-11-12T14:26:12.065Z' },
    orderStatus: 3,
    orderArchived: false,
    orderFullName: 'fake  Assigned',
    guestFullName: 'first first',
    guestDetails: new GuestDetailsBuilder().build(),
    archived: false,
    ticketPdf: 'https://apps.wix.com/events/doc/tickets/Ticket.pdf?request=Authentication',
    memberId: 'f64c1340-ae09-4d04-ba61-c0c5f1de3398',
    anonymized: false,
}); };
//# sourceMappingURL=assigned-ticket.js.map